(() => {
  function initialise(root) {
    if (root.dataset.fridgeReady) return;
    const data = root.querySelector('[data-wm-fridge-data]');
    const shelf = root.querySelector('[data-wm-fridge-jars]');
    if (!data || !shelf) return;
    const inputs = [...root.querySelectorAll('[data-wm-flavour], [data-wm-preview-count]')];
    const addons = [...root.querySelectorAll('[data-wm-addon]')];
    const door = root.querySelector('[data-wm-fridge-door]');
    const nutSlots = new Map();
    const nutBadges = new Map();
    const sizeSelect = root.querySelector('[data-wm-variant], [data-wm-preview-size]');
    const photos = new Map([...data.querySelectorAll('[data-fridge-flavour]')].map(el => [el.dataset.fridgeFlavour, el.dataset]));
    const size = () => Number(sizeSelect?.selectedOptions[0]?.dataset.size || sizeSelect?.value || 6);
    const total = () => inputs.reduce((sum, input) => sum + (Number(input.value) || 0), 0);
    const slots = [];
    for (let index = 0; index < 6; index++) {
      const slot = document.createElement('span');
      slot.className = 'wm-fridge-slot';
      slot.style.setProperty('--slot-x', `${index % 2 === 0 ? 18 : 38}%`);
      slot.style.setProperty('--slot-y', `${[38.3, 52.6, 65.6][Math.floor(index / 2)]}%`);
      shelf.append(slot);
      slots.push(slot);
    }
    inputs.forEach((input, index) => {
      const label = input.closest('label');
      const photo = photos.get(input.dataset.flavour);
      label.classList.add('wm-fridge-flavour');
      if (photo) {
        const thumb = document.createElement('span');
        thumb.className = 'wm-flavour-thumb wm-cutout';
        const image = document.createElement('img');
        image.src = photo.src;
        image.alt = '';
        image.width = 1200;
        image.height = 1200;
        thumb.append(image);
        label.prepend(thumb);
      }
      const name = photo?.name || input.dataset.flavour;
      input.id = `FridgeCount-${root.closest('[id]')?.id || 'box'}-${index}`;
      input.setAttribute('aria-label', name);
      input.inputMode = 'numeric';
      const stepper = document.createElement('span');
      stepper.className = 'wm-fridge-stepper';
      label.append(stepper);
      ['remove', 'add'].forEach(action => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.fridgeAction = action;
        button.className = `wm-fridge-bump wm-fridge-bump--${action}`;
        button.textContent = action === 'add' ? '+' : '−';
        button.setAttribute('aria-label', `${data.dataset[action]} ${name}`);
        button.addEventListener('click', event => {
          event.preventDefault();
          if (action === 'add' && total() >= size()) return;
          input.value = Math.max(0, Math.min(size(), Number(input.value) + (action === 'add' ? 1 : -1)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
        stepper.append(button);
        if (action === 'remove') stepper.append(input);
      });
      label.htmlFor = input.id;
    });
    addons.forEach((input,index) => {
      const label=input.closest('label');
      label.classList.add('wm-fridge-flavour','wm-fridge-addon');
      label.querySelector('span').classList.add('wm-nut-name');
      label.querySelector('span').dataset.shortName=input.dataset.name.split(' · ')[0];
      const thumbnail=document.createElement('img');
      thumbnail.className='wm-flavour-thumb wm-nut-thumb';
      thumbnail.src=input.dataset.photo;
      thumbnail.alt='';
      thumbnail.width=80;
      thumbnail.height=100;
      label.prepend(thumbnail);
      input.id=`FridgeNut-${root.id}-${index}`;
      input.setAttribute('aria-label',input.dataset.name);
      input.inputMode='numeric';
      label.htmlFor=input.id;
      const stepper=document.createElement('span');
      stepper.className='wm-fridge-stepper';
      label.append(stepper);
      ['remove','add'].forEach(action=>{
        const button=document.createElement('button');
        button.type='button';
        button.className=`wm-fridge-bump wm-fridge-bump--${action}`;
        button.dataset.fridgeAction=action;
        button.textContent=action==='add'?'+':'−';
        button.setAttribute('aria-label',`${data.dataset[action]} ${input.dataset.name}`);
        button.addEventListener('click',event=>{
          event.preventDefault();
          input.value=Math.max(0,Math.min(99,Number(input.value)+(action==='add'?1:-1)));
          input.dispatchEvent(new Event('input',{bubbles:true}));
        });
        stepper.append(button);
        if(action==='remove')stepper.append(input);
      });
      const slot=document.createElement('span');
      slot.className='wm-door-slot';
      slot.style.setProperty('--door-y',`${[41.5,58.5,77.5][index]}%`);
      slot.dataset.shelf=String(index);
      door.append(slot);
      ['chrome','pocket'].forEach(part=>{
        const rail=document.createElement('span');
        rail.className=`wm-door-foreground wm-door-foreground--${part}`;
        rail.dataset.shelf=String(index);
        door.append(rail);
      });
      nutSlots.set(input.dataset.nut,slot);
      const badge=document.createElement('span');
      badge.className='wm-door-count';
      badge.style.setProperty('--badge-y',`${[42.3,61,81][index]}%`);
      badge.hidden=true;
      door.append(badge);
      nutBadges.set(input.dataset.nut,badge);
    });
    let lastJarCounts=new Map(inputs.map(input=>[input.dataset.flavour,Number(input.value)||0]));
    function update() {
      const jars = [];
      inputs.forEach(input => {
        const count = Math.max(0, Math.min(size(), Number(input.value) || 0));
        const photo = photos.get(input.dataset.flavour);
        for (let n = 0; n < count && jars.length < 6; n++) if (photo) jars.push(photo);
        input.max = Math.min(size(), Number(input.dataset.stock ?? size()));
        const row = input.closest('label');
        row.querySelector('[data-fridge-action="remove"]').disabled = count === 0;
        row.querySelector('[data-fridge-action="add"]').disabled = total() >= size() || count >= Number(input.max);
      });
      const seenJarCounts=new Map();
      slots.forEach((slot, index) => {
        const photo = jars[index];
        const flavour=photo?.fridgeFlavour;
        const flavourCount=(seenJarCounts.get(flavour)||0)+1;
        seenJarCounts.set(flavour,flavourCount);
        const added=photo && flavourCount>(lastJarCounts.get(flavour)||0);
        if (slot.dataset.flavour === (photo?.fridgeFlavour || '')) return;
        slot.classList.remove('wm-jar-poof');
        slot.replaceChildren();
        slot.dataset.flavour = photo?.fridgeFlavour || '';
        if (photo) {
          const cutout = document.createElement('span');
          cutout.className = 'wm-cutout';
          const image = document.createElement('img');
          image.src = photo.src;
          image.alt = '';
          image.width = 1200;
          image.height = 1200;
          cutout.append(image);
          slot.append(cutout);
          if(added){
            slot.classList.add('wm-jar-poof');
            cutout.addEventListener('animationend',()=>slot.classList.remove('wm-jar-poof'),{once:true});
          }
        }
      });
      lastJarCounts=new Map(inputs.map(input=>[input.dataset.flavour,Number(input.value)||0]));
      addons.forEach(input=>{
        const quantity=Number(input.value)||0;
        const label=input.closest('label');
        label.querySelector('[data-fridge-action="remove"]').disabled=quantity===0;
        label.querySelector('[data-fridge-action="add"]').disabled=quantity>=99;
        const slot=nutSlots.get(input.dataset.nut);
        const bagCount=quantity*Number(input.dataset.bags||3);
        const selection=`${quantity}:${input.dataset.variant}`;
        if(slot.dataset.selection===selection)return;
        const previousBagCount=Number(slot.dataset.bagCount)||0;
        slot.dataset.selection=selection;
        slot.dataset.bagCount=String(bagCount);
        slot.dataset.quantity=String(quantity);
        const badge=nutBadges.get(input.dataset.nut);
        badge.hidden=quantity===0;
        badge.textContent=`×${bagCount}`;
        slot.replaceChildren();
        if(quantity){
          for(let bagIndex=0;bagIndex<Math.min(bagCount,Number(input.dataset.bags||3));bagIndex++){
          const bag=document.createElement('span');
          bag.className='wm-door-bag';
          bag.style.setProperty('--bag-column',bagIndex%3);
          bag.style.setProperty('--bag-depth',Math.min(3,Math.floor(bagIndex/3)));
          if(bagIndex>=previousBagCount)bag.classList.add('wm-door-bag--arriving');
          const image=document.createElement('img');
          image.src=input.dataset.photo;
          image.alt='';
          image.width=800;image.height=800;
          bag.append(image);
          slot.append(bag);
          }
        }
      });
      root.querySelector('[data-wm-fridge-tally]').textContent = `${total()} / ${size()}`;
    }
    root.addEventListener('input', event => {
      if(addons.includes(event.target)){
        event.target.value=Math.max(0,Math.min(99,Math.floor(Number(event.target.value)||0)));
        update();return;
      }
      if (!inputs.includes(event.target)) return;
      const input = event.target;
      const other = inputs.reduce((sum, item) => sum + (item === input ? 0 : Number(item.value) || 0), 0);
      input.value = Math.max(0, Math.min(size() - other, Math.floor(Number(input.value) || 0)));
      update();
    }, true);
    root.addEventListener('change', update);
    function setMix(mix) {
      inputs.forEach((input, index) => { input.value = mix[index] || 0; });
      addons.forEach(input=>{input.value=mix.length && input.dataset.nut==='dill_nuts'?1:0;});
      inputs[0]?.dispatchEvent(new Event('input', { bubbles: true }));
      update();
    }
    root.querySelector('[data-wm-fridge-reset]')?.addEventListener('click', () => setMix([]));
    root.querySelector('[data-wm-fridge-fill]')?.addEventListener('click', () => setMix(size() === 6 ? [2, 1, 1, 1, 1] : [1, 1, 1, 0, 0]));
    document.querySelectorAll('[data-wm-preset]').forEach(link=>link.addEventListener('click',event=>{
      const flavour=link.dataset.wmPreset;
      if(['snack_pickles','dill_nuts','bloody_nuts'].includes(flavour)){
        const snack=addons.find(input=>input.dataset.nut===flavour);
        if(!snack)return;
        event.preventDefault();
        snack.value=Math.max(1,Number(snack.value)||0);
        snack.dispatchEvent(new Event('input',{bubbles:true}));
      }else{
        if(!photos.has(flavour))return;
        event.preventDefault();
        setMix(inputs.map(input=>input.dataset.flavour===flavour?6:0));
      }
      root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
    }));
    if(root.dataset.preset && photos.has(root.dataset.preset))setMix(inputs.map(input=>input.dataset.flavour===root.dataset.preset?6:0));
    const panel = root.querySelector('.wm-fridge-panel');
    const flavours = root.querySelector('.wm-flavours');
    const body = root.querySelector('[data-wm-box-preview], form');
    if (panel && flavours && body) {
      root.classList.add('wm-screen-builder');
      const picker = document.createElement('div');
      picker.className = 'wm-fridge-picker';
      flavours.before(picker);
      picker.append(panel, flavours);
      const toolbar = document.createElement('div');
      toolbar.className = 'wm-fridge-toolbar';
      body.prepend(toolbar);
      const mode = body.querySelector('.wm-mode, .wm-plans');
      if (mode) toolbar.append(mode);
      const size = body.querySelector('[data-wm-preview-size]');
      if (size) {
        const group = document.createElement('div');
        group.className = 'wm-fridge-size';
        const label = body.querySelector(`label[for="${size.id}"]`);
        if (label) group.append(label);
        group.append(size);
        toolbar.append(group);
      }
      const footer = document.createElement('div');
      footer.className = 'wm-fridge-footer';
      body.append(footer);
      const price = body.querySelector('[data-wm-price]');
      if (price) footer.append(price);
      const counter = body.querySelector('[data-wm-preview-counter], [data-wm-counter]');
      if (counter) footer.append(counter);
      const actions = root.querySelector('.wm-fridge-actions');
      if (actions) footer.append(actions);
      const extras = body.querySelector('.wm-extras');
      addons.forEach(input=>flavours.append(input.closest('label')));
      extras?.remove();
      const submit = body.querySelector('[data-wm-submit], .wm-button');
      if (submit) footer.append(submit);
      const message = body.querySelector('[data-wm-message]');
      if (message) footer.append(message);
      let frame;
      function fitPanels() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!root.isConnected) { observer.disconnect(); return; }
          const height = window.visualViewport?.height || window.innerHeight;
          const header = document.querySelector('header-component');
          const announcement = document.querySelector('[id*="header_announcements"]');
          const headerHeight = (header?.getBoundingClientRect().height || 0) + (announcement?.getBoundingClientRect().height || 0);
          const previewInset = document.getElementById('PBarNextFrame') ? 64 : 0;
          root.style.setProperty('--wm-header-height',`${headerHeight}px`);
          root.style.setProperty('--wm-screen-height', `${Math.floor(height - headerHeight - previewInset)}px`);
          const bounds = picker.getBoundingClientRect();
          const mobile = window.matchMedia('(max-width: 799px)').matches;
          const gap = mobile ? 8 : 32;
          const leftRatio = mobile ? 2 : 1;
          const controlsWidth = (bounds.width - gap) / (leftRatio + 1);
          const fridgeWidth = controlsWidth * leftRatio;
          const imageRatio = 2 / 3;
          const sharedHeight = Math.max(0, Math.min(bounds.height, fridgeWidth / imageRatio));
          const imageWidth = sharedHeight * imageRatio;
          picker.style.setProperty('--wm-pair-height', `${sharedHeight}px`);
          picker.style.setProperty('--wm-image-width', `${imageWidth}px`);
          picker.style.setProperty('--wm-controls-width', `${mobile ? controlsWidth : imageWidth}px`);
        });
      }
      const observer = new ResizeObserver(fitPanels);
      observer.observe(picker);
      const header = document.querySelector('header-component');
      if (header) observer.observe(header);
      window.addEventListener('resize', fitPanels);
      window.visualViewport?.addEventListener('resize', fitPanels);
      fitPanels();
    }
    update();
    requestAnimationFrame(()=>{root.dataset.fridgeReady='true';});
  }
  document.querySelectorAll('[data-wm-box]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wm-box]').forEach(initialise));
})();
